import { jsmKbAiFirstCreateEntryPoint } from '@jira/spa-apps__jsm-kb-ai-first-create/src/jsmKbAiFirstCreateEntryPoint.entrypoint.tsx';
import { aiEntitlementResource } from '@jira/router-resources__ai-entitlement/src/aiEntitlementResource.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { jsmKbAiFirstCreateEmbedRoute } from '@jira/router-routes__servicedesk-knowledge-hub-routes/src/jsmKbAiFirstCreateEmbedRoute.tsx';
import { chromelessLayout } from '@jira/platform__layouts-chromeless-layout/src/index.tsx';
import { createChromelessEntryPoint } from '@jira/platform__routing-create-route-entry-point/src/index.tsx';
import type { Route } from '@atlassian/react-resource-router';
import { notFoundPageEntrypoint } from '@jira/router-routes__not-found-entrypoint/src/ui/error-pages/not-found/index.tsx';
import { fg } from '@atlassian/jira-feature-gating';

const JsmKbAIFirstCreatePageEntryPoint = createChromelessEntryPoint({
	main: jsmKbAiFirstCreateEntryPoint,
});

export const jsmKbAiFirstCreateEmbedRouteEntry: Route = createEntry(
	jsmKbAiFirstCreateEmbedRoute,
	() => ({
		group: 'servicedesk',
		ufoName: 'jira-jsm-kb-ai-first-create.embed-view',
		layout: chromelessLayout,
		entryPoint: () => {
			return fg('jsm_kb_from_scratch') ? JsmKbAIFirstCreatePageEntryPoint : notFoundPageEntrypoint;
		},
		resources: [aiEntitlementResource],
		bifrost: {
			bifrostGroup: 'shell-only',
		},
	}),
);
